import api from "@/api/api";
import { STATUS_HTTP } from "@/api/statusHTTP";
import { iniciarRequisicao, logout } from "@/helpers";

const PREFIXO = '/fornecedores';

export const buscarListasDePreco = async (parametros) => {
  const url = `${PREFIXO}/listas-de-preco`;

  const { data, status } = await api.post(url, parametros, {headers: iniciarRequisicao()}).catch(() => logout());

  if (status !== STATUS_HTTP.OK) logout();

  localStorage.token = data.token;
  return data.listas;
}

export const buscarProdutosListasDePreco = async (parametros) => {
  const url = `${PREFIXO}/produtos-listas-de-preco`;

  const { data, status } = await api.post(url, parametros, {headers: iniciarRequisicao()}).catch(() => logout());

  if (status !== STATUS_HTTP.OK) logout();

  localStorage.token = data.token;
  return data.lista_produtos;
}

export const editarProdutosListasDePrecoNoCarrinho = async (parametros) => {
  const url = `${PREFIXO}/ediar-produtos-listas-de-preco-no-carrinho`;

  const { data, status } = await api.post(url, parametros, {headers: iniciarRequisicao()}).catch(() => logout());

  if (status !== STATUS_HTTP.OK) logout();

  localStorage.token = data.token;
  return true;
}

export const deletarListasDePreco = async (id) => {
  const url = `${PREFIXO}/delete-lista-de-preco/${id}`;

  const { data, status } = await api.delete(url, { headers: iniciarRequisicao() }).catch(() => logout());

  if (status !== STATUS_HTTP.OK) logout();

  localStorage.token = data.token;
  return data.message;
}

export const salvarListaDePreco = async (parametros) => {
  let url = `${PREFIXO}/salvar-lista-de-preco`;

  const config = {
    headers: {
      ...iniciarRequisicao(),
      'Content-Type': 'multipart/form-data'
    }
  };

  const formData = new FormData();

  formData.append('id_grupo', parametros.id_grupo);
  formData.append('id_fornecedor', parametros.id_fornecedor);
  formData.append('data_validade', parametros.data_validade);
  formData.append('arquivo_importacao', parametros.arquivo_importacao);

  const { status, data } = await api.post(url, formData, config).catch(() => logout());

  if (status !== STATUS_HTTP.OK) logout();

  localStorage.token = data.token;
  return data.message;
}
